import { $, $$ } from "./util.js";

export function initCookie() {
  const ck = $("#cookie");
  if (!ck) return;
  const set = $("#ckSet");
  const tog = $("[data-ck=toggle]");
  const ckA = $("#ckA");
  const ckM = $("#ckM");
  let state = null;
  try {
    state = localStorage.getItem("mr_consent");
  } catch (e) {}
  if (navigator.globalPrivacyControl && !state) state = "essential";
  // Let the page paint first — a banner over the hero on load is the worst first impression.
  if (!state) setTimeout(() => { if (!state) ck.hidden = false; }, 1400);

  const save = (v) => {
    state = v;
    try {
      localStorage.setItem("mr_consent", v);
    } catch (e) {}
    ck.hidden = true;
    if (set) set.hidden = true;
    if (tog) tog.setAttribute("aria-expanded", "false");
  };

  ck.addEventListener("click", (e) => {
    const b = e.target.closest("[data-ck]");
    if (!b) return;
    const k = b.getAttribute("data-ck");
    if (k === "all") {
      if (ckA) ckA.checked = true;
      if (ckM) ckM.checked = true;
      save("all");
    } else if (k === "essential") {
      if (ckA) ckA.checked = false;
      if (ckM) ckM.checked = false;
      save("essential");
    } else if (k === "toggle" && set) {
      set.hidden = !set.hidden;
      tog.setAttribute("aria-expanded", String(!set.hidden));
    } else if (k === "save") {
      save("custom:" + (ckA && ckA.checked ? "a" : "") + (ckM && ckM.checked ? "m" : ""));
    }
  });

  $$("[data-cookie-open]").forEach((b) =>
    b.addEventListener("click", () => {
      ck.hidden = false;
      if (set) set.hidden = false;
      if (tog) tog.setAttribute("aria-expanded", "true");
      if (ckA) ckA.focus();
    })
  );
}
